var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiBotInactiveIcon = function SvgAiBotInactiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.219,
    d: "M3.047 10.576c0-1.678 0-2.516.339-3.2a3.37 3.37 0 0 1 1.366-1.413c.67-.363 1.454-.39 3.022-.444a56 56 0 0 1 3.952 0c1.568.054 2.351.081 3.022.444a3.38 3.38 0 0 1 1.366 1.414c.34.683.34 1.521.34 3.199v.786c0 1.677 0 2.516-.34 3.199a3.38 3.38 0 0 1-1.366 1.414c-.67.362-1.454.39-3.022.444a56 56 0 0 1-3.952 0c-1.568-.055-2.351-.082-3.022-.444a3.37 3.37 0 0 1-1.366-1.414c-.34-.683-.34-1.522-.34-3.199z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#697477",
    d: "M9.75 4.063a1.219 1.219 0 1 0 0-2.438 1.219 1.219 0 0 0 0 2.438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.219,
    d: "M7.719 10.664V9.242a.305.305 0 0 0-.61 0v1.422a.305.305 0 0 0 .61 0M12.39 10.664V9.242a.305.305 0 1 0-.609 0v1.422a.305.305 0 0 0 .61 0M2.844 8.734a.61.61 0 0 0-.61.61v1.625c0 .336.273.61.61.61M16.656 8.734a.61.61 0 0 1 .61.61v1.625a.61.61 0 0 1-.61.61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.975,
    d: "M9.75 5.281V2.438"
  })));
};
export { SvgAiBotInactiveIcon as ReactComponent };
export default __webpack_public_path__ + "99c41ae49a46dfdd9f6fe9b1606787ec.svg";